<template>
  <Popover ref="panelListPopover" :showHeader="true" :headerTitle="title">
    <div class="panel-popover-list" ref="panelListContainer">
      <StaticDataTable class="static-table-list" striped hover smallRows>
        <template v-slot:header>
          <tr>
            <th>Panel</th>
            <th>Panel Status</th>
            <th>Stage Status</th>
            <th>Date Due</th>
            <th>Date Completed</th>
            <th>Days Behind Schedule</th>
            <th>Order</th>
            <th>Order Status</th>
          </tr>
        </template>
        <template v-slot:body>
          <template v-for="panel in panelList">
            <tr :key="`panel-${panel.id}`">
              <td>
                <LinkProductionPanel :id="panel.id" :name="panel.barcode" />
              </td>
              <td class="text-center">
                <LabelPanelStatusBadge :status="panel.status" />
              </td>
              <td class="text-center">
                <LabelStageTaskStatusBadge :status="panel.productionPanelStageTask.status" />
              </td>
              <td class="text-center">
                {{panel.productionPanelStageTask.dueDate | formatDateTime}}
              </td>
              <td class="text-center">
                {{panel.productionPanelStageTask.completionDate | formatDateTime | formatHyphenEmptyValue}}
              </td>
              <td class="text-center">
                {{panel.productionPanelStageTask.dayDiff}}
              </td>
              <td class="text-center">
                <LinkOrder :id="panel.order.id" :name="panel.order.sequenceNumber" />
              </td>
              <td class="text-center">
                <LabelOrderStatusBadge :status="panel.order.status" />
              </td>
            </tr>
          </template>
        </template>
        <template v-slot:empty v-if="panelList.length == 0">No panels found</template>
      </StaticDataTable>
    </div>
  </Popover>
</template>

<style lang="scss" scoped>
.panel-popover-list {
  padding: 0.25rem;
  font-size: 13px;
  max-height: 40vh;
  overflow-y: scroll;
}
</style>

<script>
import _ from 'lodash'
import Popover from '@/components/popover.vue'

import LabelPanelStatusBadge from '@/modules/production/components/labelPanelStatusBadge'
import LabelStageTaskStatusBadge from '@/modules/production/components/labelStageTaskStatusBadge'
import LabelOrderStatusBadge from '@/modules/orders/components/labelOrderStatusBadge'

import { ProductionPanelStatusTypes, ProductionPanelStatusTypeLookup } from '@/store/types'

export default {
  name: 'ProductionReportPanelListPopover',
  components: {
    Popover,
    LabelPanelStatusBadge,
    LabelStageTaskStatusBadge,
    LabelOrderStatusBadge
  },
  computed: {
    title() {
      return `${this.name} at ${this.stage.name}`
    }
  },
  data() {
    return {      
      panelList: [],
      name: '',
      stage: {}
    }
  },
  created() {
    
  },
  methods: {
    displayFromElement(element, stage, panelList, name) {
      this.stage = stage
      this.panelList = panelList
      this.name = name

      this.$refs.panelListPopover.displayFromElement(element)

      this.$nextTick(() => {
        if(this.$refs.panelListContainer)
          this.$refs.panelListContainer.scrollTo(0, 0)
      })
    },
  }
}
</script>